// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"7c94c80c","306":"49902ce0","549":"1ee3ab23","729":"8a73dc49"}[chunkId] + ".chunk.css";
};